import { render, staticRenderFns } from "./EditLegalPartnerModal.vue?vue&type=template&id=547b83b3&scoped=true"
import script from "./EditLegalPartnerModal.vue?vue&type=script&lang=js"
export * from "./EditLegalPartnerModal.vue?vue&type=script&lang=js"
import style0 from "./EditLegalPartnerModal.vue?vue&type=style&index=0&id=547b83b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547b83b3",
  null
  
)

export default component.exports